import React from 'react';

import Home from '@containers/Home/Home';
import Foundations from '@containers/foundations';
import Elements from '@containers/elements';
import Components from '@containers/components';
import LibraryStatus from '@containers/libraryStatus';

import notes from '@notes';
import { renderMarkdown } from '@utils';
import { CURRENT_VERSION } from './containers/libraryStatus/constants/statusData';

/* eslint-disable react/display-name */
export const homeRoute = {
  status: 'ready',
  path: '/',
  label: 'home',
  component: () => <Home />
};

export const componentRoutes =  [
  {
    label: 'foundations',
    status: 'ready',
    path: 'foundations',
    pages: [
      {
        label: 'Colours',
        path: 'colours',
        status: 'ready',
        tabs: [
          { label: 'Swatches', component: Foundations['Colors'], path: 'swatches' },
          { label: 'Usage', component: Foundations['ColorsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.colors), path: 'readme' },
        ],
      },
      {
        label: 'Grids',
        path: 'grids',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Foundations['Grids'], path: 'library' },
          { label: 'Usage', component: Foundations['GridsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.grids), path: 'readme' },
        ],
      },
      {
        label: 'Icons',
        path: 'icons',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Foundations['Icons'], path: 'library' },
          { label: 'Usage', component: Foundations['IconsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.icons), path: 'readme' },
        ],
      },
      {
        label: 'Illustrations',
        path: 'illustrations',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Foundations['Illustrations'], path: 'library' },
          { label: 'Usage', component: Foundations['IllustrationsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.illustrations), path: 'readme' },
        ],
      },
      {
        label: 'Motion',
        path: 'motion',
        status: 'ready',
        tabs: [
          { label: 'Usage', component: Foundations['MotionUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.motion), path: 'readme' },
        ],
      },
      {
        label: 'Text Styles',
        path: 'text-styles',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Foundations['TextStyles'], path: 'library' },
          { label: 'Usage', component: Foundations['TextStylesUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.textStyles), path: 'readme' },
        ],
      },
    ],
  },
  {
    label: 'elements',
    status: 'ready',
    path: 'elements',
    pages: [
      {
        label: 'Action Icons',
        path: 'action-icons',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Elements['ActionIcons'], path: 'library' },
          { label: 'Usage', component: Elements['ActionIconsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.actionIcons), path: 'readme' },
        ],
      },
      {
        label: 'Badges',
        path: 'badges',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Elements['Badges'], path: 'library' },
          { label: 'Usage', component: Elements['BadgesUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.badges), path: 'readme' }
        ],
      },
      {
        label: 'Buttons',
        path: 'buttons',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Elements['Buttons'], path: 'library' },
          { label: 'Usage', component: Elements['ButtonsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.buttons), path: 'readme' }
        ],
      },
      {
        label: 'Dividers',
        path: 'dividers',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Elements['Dividers'], path: 'library' },
          { label: 'Usage', component: Elements['DividersUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.dividers), path: 'readme' },
        ],
      },
      {
        label: 'Inputs',
        path: 'inputs',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Elements['Inputs'], path: 'library' },
          { label: 'Usage', component: Elements['InputsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.inputs), path: 'readme' },
        ],
      },
      {
        label: 'Links',
        path: 'links',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Elements['Links'], path: 'library' },
          { label: 'Usage', component: Elements['LinksUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.links), path: 'readme' },
        ],
      },
      {
        label: 'Loadings',
        path: 'loadings',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Elements['Loadings'], path: 'library' },
          { label: 'Usage', component: Elements['LoadingsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.loadings), path: 'readme' }
        ],
      },
      {
        label: 'Pagination',
        path: 'pagination',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Elements['Paginations'], path: 'paginations' },
          { label: 'Usage', component: Elements['PaginationsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.paginations), path: 'readme' },
        ],
      },
      {
        label: 'Tabs',
        path: 'tabs',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Elements['Tabs'], path: 'library' },
          { label: 'Usage', component: Elements['TabsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.tabs), path: 'readme' },
        ],
      },
      {
        label: 'Tooltips',
        path: 'tooltips',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Elements['Tooltips'], path: 'library' },
          { label: 'Usage', component: Elements['TooltipsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.tooltips), path: 'readme' },
        ],
      },
      {
        label: 'Tags',
        path: 'tags',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Elements['Tags'], path: 'library' },
          { label: 'Usage', component: Elements['TagsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.tags), path: 'readme' },
        ],
      },
      {
        label: 'Toggles',
        path: 'toggles',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Elements['Toggles'], path: 'library' },
          { label: 'Usage', component: Elements['TogglesUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.toggles), path: 'readme' },
        ],
      },
    ],
  },
  {
    label: 'components',
    status: 'ready',
    path: 'components',
    pages: [
      {
        label: 'Accordions',
        path: 'accordions',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Components['Accordions'], path: 'library' },
          { label: 'Usage', component: Components['AccordionsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.accordions), path: 'readme' },
        ],
      },
      {
        label: 'Banners',
        path: 'banners',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Components['Banners'], path: 'library' },
          { label: 'Usage', component: Components['BannersUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.banners), path: 'readme' },
        ],
      },
      {
        label: 'Footer',
        path: 'footer',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Components['Footers'], path: 'library' },
          { label: 'Usage', component: Components['FootersUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.footer), path: 'readme' },
        ],
      },
      {
        label: 'Form',
        path: 'form',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Components['Forms'], path: 'library' },
          { label: 'Usage', component: Components['FormsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.form), path: 'readme' },
        ]
      },
      {
        label: 'Header',
        path: 'header',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Components['Headers'], path: 'library' },
          { label: 'Usage', component: Components['HeadersUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.header), path: 'readme' },
        ],
      },
      {
        label: 'Hotspots',
        path: 'hotspots',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Components['Hotspots'], path: 'library' },
          { label: 'Usage', component: Components['HotspotsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.hotspots), path: 'readme' },
        ],
      },
      {
        label: 'Maps',
        path: 'maps',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Components['Maps'], path: 'library' },
          { label: 'Usage', component: Components['MapsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.map), path: 'readme' },
        ],
      },
      {
        label: 'Notifications',
        path: 'notifications',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Components['Notifications'], path: 'library' },
          { label: 'Usage', component: Components['NotificationsUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.notifications), path: 'readme' },
        ],
      },
      {
        label: 'Vertical Section Marker',
        path: 'vertical-section-marker',
        status: 'ready',
        tabs: [
          { label: 'Library', component: Components['VerticalSectionMarker'], path: 'library' },
          { label: 'Usage', component: Components['VerticalSectionMarkerUsage'], path: 'usage' },
          { label: 'Readme', component: renderMarkdown(notes.verticalSectionMarker), path: 'readme' },
        ],
      },
    ]
  },
  {
    label: 'compositions',
    status: 'wip',
    path: 'compositions',
    pages: [],
  },
];

export const docRoutes = [
  {
    label: 'Library Status',
    status: 'ready',
    path: 'library-status',
    subtitle: `Current Version: ${CURRENT_VERSION}`,
    tabs: [
      { label: 'Status', component: LibraryStatus['Status'], path: 'status' },
      { label: 'Release Notes', component: LibraryStatus['ReleaseNotes'], path: 'release-notes' },
    ],
  },
  {
    label: 'Git Repo',
    status: 'ready',
    path: 'https://gitlab.com/tekzenit-pt/airtel/airtel-web-uis',
  },
];




// WEBPACK FOOTER //
// ./src/routeConfig.js